<template>
    <div  ref="containerRef">
        <!-- 查询 -->
        <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleQuerySelectChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表头自定义按钮 -->
            <template v-slot:operateBtn>
                <a-button type="primary" size="small" class="operate_btn" @click="handle('add')">
                    <component :is="$antIcons['PlusOutlined']"></component>
                    {{$t('base.add')}}
                </a-button>
            </template>
            
            <!-- 表格列自定义列内容 -->
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val === 0 ? 'green' : 'red'"
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
                <template v-if="props.column.key === 'role_type'">
                    <div class="editable-cell"> 
                        <a-tag
                            v-if="props.record.role_type_val !== undefined"
                            :color="props.record.role_type_val === 0 ? 'green' : 'blue'"
                        >{{ props.record.role_type }}</a-tag>
                        <span v-else>-</span>
                    </div>
                </template>
            </template>

            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" :disabled="props.record.status_val == 1" style="margin-right:10px" @click="handle('stop',props.record)">
                        {{$t('user.stop')}}
                    </a-button>
                    <a-button type="link" size="small" :disabled="props.record.status_val == 0" style="margin-right:10px" @click="handle('enable',props.record)">
                        {{$t('user.enable')}}
                    </a-button>
                    <a-button type="link" size="small" :disabled="props.record.status_val == 0" style="margin-right:10px" @click="handle('delete',props.record)">
                        {{$t('base.delete')}}
                    </a-button>
                    <a-button type="link" size="small" :disabled="props.record.status_val == 1" style="margin-right:10px" @click="handle('editPwd',props.record)">
                        {{$t('user.editPassword')}}
                    </a-button>
                </template>
            </template>
        </Table>

        <!-- 新增用户 -->
        <a-modal 
            v-model:visible="visible" 
            :title="t('user.add_user')" 
            width="700px"
            :getContainer="getContainer"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <a-form layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('user.role_type')" v-bind="validateInfos.role_type">
                    <a-radio-group v-model:value="formState.role_type" @change="changeRadio">
                        <a-radio :value="0">{{ $t('user.admin') }}</a-radio>
                        <a-radio :value="1">{{ $t('user.publishedNoticeUser') }}</a-radio>
                        <a-radio :value="2">{{ $t('user.fileUploadUser') }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="t('user.user_name')" v-bind="validateInfos.user_name">
                    <a-input v-model:value="formState.user_name" allowClear :maxlength="50" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('user.full_name')" v-bind="validateInfos.full_name">
                    <a-input v-model:value="formState.full_name" allowClear :maxlength="50" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('user.password')" v-bind="validateInfos.password">
                    <a-input-password v-model:value="formState.password" allowClear :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('user.confirm_password')" v-bind="validateInfos.confirm_password">
                    <a-input-password v-model:value="formState.confirm_password" allowClear :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('notice.relateApp')" v-bind="validateInfos.app_id">
                    <a-select 
                        v-model:value="formState.app_id" 
                        allowClear 
                        :options="appOptions"
                        :placeholder="t('base.select')" 
                        @change="changeSelect('app')"
                    />
                    <div style="color:#999;font-size:13px">{{ $t('user.app_id_msg') }}</div>
                </a-form-item>
                <a-form-item label="关联的客户" v-bind="validateInfos.customer_code">
                    <a-select 
                        v-model:value="formState.customer_code" 
                        allowClear 
                        :options="customerOptions"
                        :placeholder="t('base.select')" 
                        :disabled="customerDisabled"
                    />
                    <div style="color:#999;font-size:13px">若无数据，请到【客户管理】进行维护</div>
                </a-form-item>
                <a-form-item :label="t('user.mobile')">
                    <a-input v-model:value="formState.mobile" :maxlength="11" allowClear :placeholder="t('base.enter')" />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 管理员修改用户密码 -->
        <a-modal 
            v-model:visible="editPwdVisible" 
            :title="t('user.editPassword')" 
            width="700px"
            @cancel="handleCancel"
            @ok="editPassword"
        >
            <a-form layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('user.user_name')" >
                    <a-input v-model:value="rowData.user_name" disabled  />
                </a-form-item>
                <a-form-item :label="t('user.password')" v-bind="validateInfos.password">
                    <a-input-password v-model:value="formState.password" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('user.confirm_password')" v-bind="validateInfos.confirm_password">
                    <a-input-password v-model:value="formState.confirm_password" :placeholder="t('base.enter')" />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>  
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    import { QueryForm, AddForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue'; 
    import { UserApi } from '@/api/UserApi.js';
    import { SmallProgramApi } from '@/api/SmallProgramApi.js';
    import { CodeApi } from '@/api/CodeApi.js';
    import { debounce } from 'lodash-es';
    import { timestampToDate } from '@/utils/global.js'
    import { Form } from 'ant-design-vue';

    const { t } = useI18n()

    const GOBAOID = 'wx12360923facd605a' // 正式：wx0dc05f95f965d69a     测试：123456
    const useForm = Form.useForm
    const userInfo = ref(JSON.parse(localStorage.getItem('hd_ota_loginUser')))
    const queryForm = reactive(QueryForm)
    const visible = ref(false)
    const editPwdVisible = ref(false)
    const rowData = ref(null)
    const customerDisabled = ref(false)
    const appOptions = ref([{
        label:'无',
        value:'-',
        disabled:false,
    }])
    const customerOptions = ref([])
    const containerRef = ref(null)
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('user.user_name'),//'姓名'
                dataIndex: 'user_name',
                key: 'user_name',
                width: 70,
                resizable: true,
                locel:'user.user_name',
            },
            {
                title: t('user.full_name'),//'全名'
                dataIndex: 'full_name',
                key: 'full_name',
                width: 100,
                resizable: true,
                locel:'user.full_name',
            },
            {
                title: t('user.mobile'),//'手机号'
                dataIndex: 'mobile',
                key: 'mobile',
                width: 120,
                resizable: true,
                locel:'user.mobile',
            },
            {
                title: t('notice.relateApp'),//'关联的小程序'
                dataIndex: 'app_name',
                key: 'app_name',
                width: 100,
                resizable: true,
                locel:'user.app_name',
            },
            {
                title: '关联的客户',
                dataIndex: 'customer_name',
                key: 'customer_name',
                width: 100,
                resizable: true,
                locel:'user.customer_name',
            },
            {
                title: t('user.role_type'),//'角色类型'
                dataIndex: 'role_type',
                key: 'role_type',
                width: 100,
                resizable: true,
                locel:'user.role_type',
            },
            {
                title: t('user.user_type'),//'用户类型'
                dataIndex: 'user_type',
                key: 'user_type',
                width: 100,
                resizable: true,
                locel:'user.user_type',
            },
            {
                title: t('user.status'),//'启用状态'
                dataIndex: 'status',
                key: 'status',
                width: 120,
                resizable: true,
                locel:'user.status',
            },
            {
                title: t('user.create_timestamp'),//'创建日期'
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                width: 120,
                resizable: true,
                locel:'user.create_timestamp',
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 230,
                resizable: true,
            },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })
    const formState = reactive({
        user_name:'',
        full_name:'',
        password:'',
        confirm_password:'',
        app_id:'',
        customer_code:'',
        role_type:'',
        mobile:'',
    })
    const rulesRef = reactive({
        user_name: [
            {
                required: true,
                message: '账号不能为空！',
            },
        ],
        full_name: [
            {
                required: true,
                message: '昵称不能为空！',
            },
        ],
        password: [
            {
                required: true,
                message: '密码不能为空！',
            },
        ],
        confirm_password: [
            {
                required: true,
                message: '确认密码不能为空！',
            },
        ],
        app_id: [
            {
                required: true,
                message: 'app id不能为空！',
            },
        ],
        customer_code: [
            {
                required: true,
                message: '客户不能为空！',
            },
        ],
        role_type: [
            {
                required: true,
                message: '角色类型不能为空！',
            },
        ],
    });

    const handleInputChange = debounce((val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }, 1000)

    const handleQueryPressEnter = (val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    const handleQuerySelectChange = (val, key)=>{
        console.log(val,'sssss')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    // 分页
    function handleChangePagination(config, data) {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const getContainer = ()=>{
        return containerRef.value
    }

    const changeRadio = (val)=>{
        console.log(val,'val',formState.role_type)
        formState.app_id = ''
        formState.customer_code = ''
        appOptions.value[0].disabled = formState.role_type == 1
    }

    const changeSelect = (key)=>{
        if(key == 'app'){
            if(formState.app_id == GOBAOID){
                rulesRef.customer_code[0].required = true
                customerDisabled.value = false
                getCustomerList()
            }else{
                rulesRef.customer_code[0].required = false
                customerOptions.value = []
                formState.customer_code = ''
                customerDisabled.value = true
            }
        }
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                visible.value = true
                for(let key in formState){
                    formState[key] = ''
                }
                resetFields()
                break;
            case 'stop':
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认将该账号禁用? 禁用后，账号将无法登录系统！',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        changeUserStatus(1, row)
                    },
                });
                break;
            case 'enable':
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认启用该账号? ',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        changeUserStatus(0, row)
                    },
                });
                break;
            case 'delete':
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认删除该账号? ',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        changeUserStatus(2, row)
                    },
                });
                break;
            case 'editPwd':
                editPwdVisible.value = true
                formState.password = ''
                formState.confirm_password = ''
                rowData.value = row
                break;
        }
    }

    // 获取用户列表
    const getList = async ()=> {
        let param = {
            ...queryForm.formData,
            status: queryForm.formData.status == null? '' : queryForm.formData.status
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await UserApi.getInstance().getUserList(param, page_num, page_size)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.serial = index + 1
                i.mobile = !i.mobile? '-' : i.mobile
                i.status_val = i.status == undefined? '-' : i.status
                i.status = i.status == 0? t('user.normal') : t('user.stop')
                i.role_type_val = i.role_type
                i.role_type = i.role_type == undefined? '-' : i.role_type == 0? t('user.admin') : (i.role_type == 1? t('user.publishedNoticeUser') : t('user.fileUploadUser'))
                i.create_timestamp = i.create_timestamp == undefined? '-' : timestampToDate(i.create_timestamp) 
                i.user_type = i.user_type == undefined? '-' : i.user_type === 0? t('user.app') : t('user.backend')
                i.full_name = !i.full_name? '-' : i.full_name
                i.app_name = !i.app_name? '-' : i.app_name
                i.customer_name = !i.customer_name? '-' : i.customer_name
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

     // 获取用户小程序名称
     const getAppNameList = async ()=> {
        let param = {
            status:0,
        }
        let res = await SmallProgramApi.getInstance().getSmallProgramQuery(param)
        if (res.code == 0) {
            appOptions.value = [{
                label:'无',
                value:'-',
                disabled:false,
            }]
            res.data.length > 0 && res.data.forEach(item=>{
                appOptions.value.push({
                    label: item.app_name,
                    value: item.app_id,
                })
            })

            queryForm.formField.find(item=>item.key == 'app_id').options = appOptions.value.slice(1)
        } else {
            message.error(res.msg);
        }
    } 

    const getCustomerOpt = async ()=> {
        let param = {
            dict_type:0,
        }
        let res = await CodeApi.getInstance().getParentOpt(param)
        if (res.code == 0) {
            queryForm.formField.find(item=>item.key == 'customer_code').options = res.data.map(item=>({
                label: item.dict_name,
                value: item.dict_code,
            }))
        }else{
            message.error(res.msg);
        }
    }


    // 获取客户列表
    const getCustomerList = async ()=> {
        let param = {
            app_id: formState.app_id,
            dict_type: '0',
        }
        let res = await UserApi.getInstance().getCustomerList(param)
        if (res.code == 0) {
            customerOptions.value = []
            res.data.length > 0 && res.data.forEach(item=>{
                customerOptions.value.push({
                    label: item.dict_name,
                    value: item.dict_code,
                })
            })
        } else {
            message.error(res.msg);
        }
    }

    // 新增用户
    const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    const handleOk = ()=>{
        validate().then(async () => {
            let reg_pwd = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/
            let reg_mobile = /^(?:\+86\s?)?1[3-9]\d{9}$/

            if(!reg_pwd.test(formState.password)){
                message.error('密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(!reg_pwd.test(formState.confirm_password)){
                message.error('确认密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(formState.password != formState.confirm_password){
                message.error('两次输入的密码不一致！');
                return
            }else if(formState.mobile && !reg_mobile.test(formState.mobile)){
                message.error('手机号格式不正确！');
                return
            }

            let param = {}
            for(let key in formState){
                if(key == 'app_id'){
                    param[key] = formState[key] == '-'? '' : formState[key]
                }else if(key !== 'confirm_password'){
                    param[key] = formState[key]
                }
            }

            let res = await UserApi.getInstance().addUser(param)
            if (res.code == 0) {
                message.success('新增成功！');
                visible.value = false
                table.value.configs.pagination.current = 1
                getList()
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }
    const handleCancel = ()=>{
        resetFields()
    }

    // 禁用/启用/删除 用户账号
    const changeUserStatus = async (status,row)=>{
        let param = {
            status: status
        }
        let res = await UserApi.getInstance().changeUserStatus(param, row.id)
        if (res.code == 0) {
            table.value.configs.pagination.current = 1
            getList()
        } else {
            message.error(res.msg);
        }
    }

    // 修改密码
    const editPassword = ()=>{
        rulesRef.user_name[0].required = false
        rulesRef.full_name[0].required = false
        rulesRef.app_id[0].required = false
        rulesRef.role_type[0].required = false

        validate().then(async () => {
            let reg_pwd = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/
            if(!reg_pwd.test(formState.password)){
                message.error('密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(!reg_pwd.test(formState.confirm_password)){
                message.error('确认密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(formState.password != formState.confirm_password){
                message.error('两次输入的密码不一致！');
                return
            }

            let param = {
                new_password: formState.password
            }
            let res = await UserApi.getInstance().editPasswordByAdmin(param, rowData.value.id)
            if (res.code == 0) {
                message.success('密码修改成功！');
                editPwdVisible.value = false
                table.value.configs.pagination.current = 1
                getList()
                resetFields()
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }
    

    onMounted(()=>{
        getList()
        getAppNameList()
        getCustomerOpt()
    })
    
</script>

<style lang="scss" scoped>
.searchPanel{
    margin-bottom: 5px;
    background: #fff;
    border-bottom: 1px dashed #ddd;

    ::v-deep .ant-form-item{
        margin-bottom: 4px;
    }
}

::v-deep .ant-table tfoot>tr>td, 
::v-deep .ant-table tfoot>tr>th, 
::v-deep .ant-table-tbody>tr>td, 
::v-deep .ant-table-thead>tr>th {
    overflow-wrap: break-word;
    padding: 14px;
    position: relative;
}

::v-deep .ant-modal-body{
    height: 600px;
    overflow-y: scroll;
}
</style>